<template>
  <div>
    <b-modal id="modal-riwayat" size="xl" centered :title="$store.state.modal.riwayatPelamarKerja" header-bg-variant="warning" header-text-variant="light">
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-table
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            stacked="md"
            responsive
            show-empty
            small
            @filtered="onFiltered"
            bordered
            striped
            hover
            :busy="tableBusy"
          >
            <template #cell(no)="item">
              {{ item.index + 1 }}
            </template>
            <template #cell(statusPostLoker)="item">
              <p v-if="item.item.statusPostLoker == 0">
                {{ $store.state.text.aktif }}
              </p>
              <p v-if="item.item.statusPostLoker == 1">
                {{ $store.state.text.tahapKelengkapanDokumen }}
              </p>
              <p v-if="item.item.statusPostLoker == 2">
                {{ $store.state.text.tidakLolosKelengkapanDokumen }}
              </p>
              <p v-if="item.item.statusPostLoker == 3">{{ $store.state.text.tidakLolosTahapan }} {{ item.item.namaTahapan }}</p>
              <p v-if="item.item.statusPostLoker == 4">
                {{ $store.state.text.diterima }}
              </p>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-riwayat')">Batal</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalEdit",
  props: ["data", "detail"],

  data() {
    return {
      busy: false,
      button: "Simpan",
      items: [
        {
          no: "-",
          pelamar: "-",
          alamat: "-",
          email: "-",
          posisiDilamar: "-",
          status: "-",
        },
      ],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaPengirim",
          label: "Nama Pelamar",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "alamatPengirim",
          label: "Alamat",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "emailPengirim",
          label: "Email",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaLoker",
          label: "Posisi Yang Dilamar",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "statusPostLoker",
          label: "Status",
          class: "table-option-4 text-center",
        },
        {
          key: "keterangan",
          label: "Keterangan",
          class: "table-option-4 text-center",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      tableBusy: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    data: {
      statusPostLoker: {
        required,
      },
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    async getRiwayat() {
      let vm = this;
      let riwayat = await vm.$axios.post("postLoker/listRiwayatDitolak", {
        nomorKTP: vm.data.nomorKTPPengirim,
      });
      vm.items = riwayat.data.data;
      for (let i = 0; i < vm.items.length; i++) {
        if (vm.items[i].tahapan.length) {
          vm.items[i].namaTahapan = vm.items[i].tahapan[0].namaTahapan;
          vm.items[i].keterangan = vm.items[i].tahapan[0].keteranganPoolTahapan;
        }
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  watch: {
    detail: function (newVal, oldVal) {
      if (oldVal != newVal) {
        console.log(this.data);
        this.getRiwayat();
      }
    },
  },
};
</script>
